var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jobs row"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_c('div',{staticClass:"row",attrs:{"id":"oportunidades"}},[_c('div',{staticClass:"col-10 mx-auto"},[_c('h1',[_vm._v("Nossas oportunidades")]),_c('Jobs',{key:_vm.$route.fullPath})],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('section',{staticClass:"banner d-flex justify-content-center"})])
}]

export { render, staticRenderFns }